import { __extends } from "tslib";
import { GetSmsTemplateRequest, GetSmsTemplateResponse } from "../models/index";
import { deserializeAws_restJson1GetSmsTemplateCommand, serializeAws_restJson1GetSmsTemplateCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetSmsTemplateCommand = /** @class */ (function (_super) {
    __extends(GetSmsTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetSmsTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetSmsTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetSmsTemplateRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetSmsTemplateResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetSmsTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetSmsTemplateCommand(input, context);
    };
    GetSmsTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetSmsTemplateCommand(output, context);
    };
    return GetSmsTemplateCommand;
}($Command));
export { GetSmsTemplateCommand };
//# sourceMappingURL=GetSmsTemplateCommand.js.map